import angular from 'angular'
import moment from 'moment'
import templateUrl from './event-scheduling-tsu-summary-report.component.html'

export const EventsSchedulingTsuSummaryReportComponent = {
    controller: EventsSchedulingTsuSummaryReportController,
    templateUrl,
    controllerAs: "vm",
    bindings: {
        params: "<"
    }
}

function EventsSchedulingTsuSummaryReportController($q, apexApiUrl, utilityService, scheduleEventService) {

    'ngInject'
    const vm = this;
    vm.$onInit = activate;
    vm.$onChanges = onChanges;
    vm.pageNumber = 1;
    vm.pageSize = 50;
    vm.loaded = false;
    vm.onChangeFilter = onChangeFilter;

    function activate() {
    }


    function loadScheduleEventTsuSummaryReport() {
        const params = vm.params;
        utilityService.showLoading();
        scheduleEventService.retrieveScheduleEventTsuSummaryReport(params)
            .then(function (reports) {
                vm.scheduleEvents = reports;
                vm.filteredScheduleEvents = angular.copy(vm.scheduleEvents);
                calculateTotals();
                return reports;
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }


    function onChanges(changes) {
        if (changes.params) {
            loadScheduleEventTsuSummaryReport();
        }
    }

    function onChangeFilter() {
        vm.filteredScheduleEvents = angular.copy(vm.scheduleEvents);
        vm.filteredScheduleEvents = vm.filteredScheduleEvents.filter(filterScheduleEvents);
        calculateTotals();
    }

    function filterScheduleEvents(event) {

        const ownerClinetName = event.OwnerName + " - " + event.ClientName;

        return (!vm.filters.OwnerClientName || utilityService.containsInvariant(ownerClinetName,
            vm.filters.OwnerClientName))
            && (!vm.filters.HostLocationName || utilityService.containsInvariant(event.HostLocationName,
                vm.filters.HostLocationName))
            && (!vm.filters.HostType || utilityService.containsInvariant(event.HostType,
                vm.filters.HostType))
            && (!vm.filters.HostName || utilityService.containsInvariant(event.HostName, vm.filters.HostName))
            && (!vm.filters.StartDate || moment(vm.filters.StartDate).isSame(event.StartDate))
            && (!vm.filters.EndDate || moment(vm.filters.EndDate).isSame(event.EndDate));
    }

    function calculateTotals() {
        const total = {
            NoOfDays: 0,
            TsuBooked: 0
        }
        vm.eventTotals = vm.filteredScheduleEvents.reduce(function (totals, payout) {
            totals.NoOfDays += payout.NumberOfDays;
            totals.TsuBooked += payout.TsuCount;
            return totals;
        }, total);
        if (vm.eventTotals.NoOfDays > 0) {
            vm.eventTotals.AvgPerDay = vm.eventTotals.TsuBooked / vm.eventTotals.NoOfDays;
        } else {
            vm.eventTotals.AvgPerDay = 0;
        }
    }
}
